(ns frontend.view.reports.custom.diamond-edge-ventures.report-2-total-engagement
  (:require
   [common.entity :as entity]
   [frontend.state.current-session :as session]
   [common.util :as cu]))

(def sept-1-2018 1535760000000)

(defn oppos-in-scope
  [{:keys [start-date end-date]}]
  (let [deals-pipeline-id (->> @session/pipelines
                               (cu/filter-by :pipeline/entity-type :entity.type/oppo)
                               (cu/filter-by :pipeline/name "Commercialization")
                               (first)
                               (:db/id))
        start-date-millis (if start-date (.getTime start-date) nil)
        end-date-millis (if end-date (.getTime end-date) nil)
        filtered-oppos
        (->> @session/oppos
             (cu/filter-by :oppo/pipeline deals-pipeline-id)
             (filter (fn [o]
                       (> (:common/created-on o) sept-1-2018)))
             (filter (fn [o]
                       (and
                        (if start-date-millis (>= (:common/created-on o) start-date-millis) true)
                        (if end-date-millis (<= (:common/created-on o) end-date-millis) true))))
        )]
    filtered-oppos))


(defn oppos-by-status-or-deal-type
  [filter-state]
  (let [stages-by-name (->> @session/stages
                            (map (fn [s]
                                   [(:stage/name s) s]))
                            (into {}))
        stage-ords (->> @session/stages
                        (map (fn [s]
                               [(:db/id s) (:common/ord s)]))
                        (into {}))
        trial-with-bu-stage (:db/id (get stages-by-name "Trial with BU"))
        NDA-MTA-stage (:db/id (get stages-by-name "NDA/MTA"))
        evaluation-stage (:db/id (get stages-by-name "Evaluation"))
        partnerships-stage (:db/id (get stages-by-name "Partnership"))
        business-stage (:db/id (get stages-by-name "Business"))
        scope-stage-with-labels [[[trial-with-bu-stage] "Trial with BU"]
                                 [[NDA-MTA-stage] "NDA/MTA"]
                                 [[evaluation-stage] "Evaluation"]
                                 [[partnerships-stage] "Partnership"]
                                 [[business-stage] "Business"]]
        deal-type-lookup (->> (session/named-values :oppo/tag-deal-type)
                              (map (fn [nv]
                                     [(:named-value/value nv)
                                      (:db/id nv)]))
                              (into {}))
        transfer-to-BU (get deal-type-lookup "Transfer to BU")
        {:keys [start-date end-date]} @filter-state
        start-date-millis (if start-date (.getTime start-date) nil)
        end-date-millis (if end-date (.getTime end-date) nil)

        oppos (oppos-in-scope @filter-state)
        row-datas
        (cond
          (not transfer-to-BU)
          "'Transfer to BU' not found"
          :else
          (->>
           scope-stage-with-labels
           (mapv
            (fn [[stage-ids label]]
              (let [min-stage-ord (->> stage-ids
                                       (map stage-ords)
                                       (remove nil?)
                                       (apply min))
                    max-stage-ord (->> stage-ids
                                       (map stage-ords)
                                       (remove nil?)
                                       (apply max))
                    oppos-in-or-beyond-stage (->> oppos
                                                  (filter (fn [o]
                                                            (>= (get stage-ords (:oppo/stage o))
                                                                min-stage-ord))))
                    oppos-step-up
                    (->> oppos-in-or-beyond-stage
                         (filter (fn [o]
                                   (let [stage-changes (:common/change-meta o)
                                         last-enter (->> stage-changes
                                                         (filter (fn [sc]
                                                                   (some #{(get-in sc [:change/value :enter-stage])}
                                                                         stage-ids)))
                                                         (map :common/updated-on)
                                                         (sort)
                                                         (last))]
                                     (< start-date last-enter end-date)))))
                    oppos-in-stage-scope (->> oppos-in-or-beyond-stage
                                              (filter (fn [o]
                                                        (<= (get stage-ords (:oppo/stage o))
                                                            max-stage-ord))))
                    passed-count (->> oppos-in-stage-scope
                                      (cu/filter-by :oppo/status :oppo.status/passed)
                                      (count))
                    on-hold-count (->> oppos-in-stage-scope
                                       (cu/filter-by :oppo/status :oppo.status/on-hold)
                                       (count))
                    active-count (->> oppos-in-stage-scope
                                      (cu/filter-by :oppo/status :oppo.status/ok)
                                      (count))
                    portfolio-count (->> oppos-in-stage-scope
                                         (cu/filter-by :oppo/status :oppo.status/portfolio)
                                         (count))
                    transfered-to-bu-count (->> oppos-in-stage-scope
                                                (filter (fn [o]
                                                          (some #{transfer-to-BU} (:oppo/tag-deal-type o))))
                                                (count))
                    step-up-count (count oppos-step-up)
                    total-count
                    (+ passed-count on-hold-count active-count)]
                [label passed-count on-hold-count active-count portfolio-count transfered-to-bu-count step-up-count
                 total-count])))))]

    (if (string? row-datas)
      [["Error" row-datas]]
      (let [total-counts (concat (->> (range 1 (- (count (first row-datas)) 2))
                                      (mapv (fn [idx]
                                              (->> row-datas
                                                   (map (fn [rd]
                                                          (nth rd idx 0)))
                                                   (filter number?)
                                                   (apply +)))))
                                 [""
                                  (->> row-datas
                                       (map last)
                                       (filter number?)
                                       (apply +))])]
        (vec (concat row-datas
                     [(vec (concat ["Total"] total-counts))]))))))
